import { createElementBlock as o, openBlock as n, createElementVNode as l } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(d, e) {
  return n(), o("svg", r, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.29 7.294a1 1 0 0 1 1.415 0l8 8a1 1 0 0 1-1.414 1.414l-8-8a1 1 0 0 1 0-1.414",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.255 19.376a1 1 0 0 1-.386 1.36 10 10 0 0 1-11.711-1.442A10.004 10.004 0 0 1 3.534 6.673a1 1 0 1 1 1.693 1.063 8.01 8.01 0 0 0 1.3 10.1 8 8 0 0 0 9.368 1.153 1 1 0 0 1 1.36.387M18.846 16.14a8.01 8.01 0 0 0-1.365-9.963A8 8 0 0 0 8.1 5.012a1 1 0 0 1-.974-1.747 10 10 0 0 1 11.725 1.456 10.005 10.005 0 0 1 1.707 12.452 1 1 0 1 1-1.713-1.033",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_not_allowed-DyxU4aJw.js.map
